/**
 * Created by BETALOS on 12/10/2016.
 */
(function () {
    'use strict';

    class ActorService {
        constructor($q, $http, storageService) {
            this.q = $q;
            this.http = $http;
            this.storageService = storageService;
        }

        static get $inject() {
            return ['$q', '$http', 'storageService'];
        }

        getSpecialities() {
            const deferred = this.q.defer();
            const url = `/api/medical-speciality/`;

            this.http.get(url)
                .then(response => deferred.resolve(response.data), deferred.reject);

            return deferred.promise
        }

        handleSpeciality(speciality) {
            const deferred = this.q.defer();
            const url = `/api/medical-speciality/${_.isNil(speciality.id) ? '' : speciality.id + '/'}`;

            this.http.post(url, speciality)
                .then(success, deferred.reject);

            function success(response) {
                deferred.resolve(response.data);
            }

            return deferred.promise
        }

        getStaff(staff) {
            const deferred = this.q.defer();
            const url = `/api/staff/${staff}/`;

            this.http.get(url)
                .then(response => deferred.resolve(response.data), deferred.reject);


            return deferred.promise;
        }

        getStaffList() {
            const url = "/api/staff-list/";
            const deferred = this.q.defer();

            this.http.get(url)
                .then(response => deferred.resolve(response.data), deferred.reject);


            return deferred.promise;
        }

        handleStaff(staff) { //user
            const deferred = this.q.defer();
            const url = `/api/${staff['is_physician'] ? 'physician' : 'staff'}/${_.has(staff, 'id') ? staff.id + '/' : ''}?logout=1`;

            staff.users = _.reduce(staff.users, (result, user) => {
                if (_.isNil(user.id)) user.password = user['new_password'];

                user.is_active = staff.is_active;
                result.push(user);

                return result;
            }, []);

            this.http.post(url, staff)
                .then(response => {
                    if (staff.is_physician) {
                        this.storageService.removeKey("minimal-physician");
                    }

                    deferred.resolve(response.data);
                }, deferred.reject);


            return deferred.promise;
        }

        partialUpdateStaff(staff) {
            const deferred = this.q.defer();
            const url = `/api/${staff['is_physician'] ? 'physician' : 'staff'}/${staff.id}/`;

            this.http.put(url, staff)
                .then(response => deferred.resolve(response.data), deferred.reject);

            return deferred.promise;
        }

        getServices() {
            const url = "/api/service/";
            const deferred = this.q.defer();

            this.http.get(url)
                .then(response => deferred.resolve(response.data), deferred.reject);

            return deferred.promise;
        }

    }

    module.exports = ActorService;

})();
